import { useFormikContext } from 'formik';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { optionsStyle } from '../composables';
import { getDietExercises } from '../../../../redux/visit';
import useDebounce from '../../../../utils/useDebounceHook';

const DietExercise = () => {
	const { values, setFieldValue } = useFormikContext();
	const [dietExerciseOptions, setDietExerciseOptions] = useState([]);
	const { dietExercises } = useSelector((state) => state.visits);
	const dispatch = useDispatch();
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearch = useDebounce(searchTerm, 500);

	useEffect(() => {
		if (dietExercises.length > 0) {
			const newOptions = dietExercises.map((a) => ({
				value: a.id,
				label: a.name,
				isNew: false,
			}));

			setDietExerciseOptions((prev) => {
				const merged = [...prev, ...newOptions];
				return merged.filter(
					(opt, index, self) =>
						index === self.findIndex((o) => o.value === opt.value)
				);
			});
		}
	}, [dietExercises]);

	useEffect(() => {
		if (debouncedSearch) {
			dispatch(
				getDietExercises({
					search: debouncedSearch,
					per_page: 5,
					status: 'active',
				})
			);
		}
	}, [debouncedSearch, dispatch]);

	const handleChange = (selected) => {
		const mapped = (selected || [])
			.map((opt) => {
				if ((opt.__isNew__ || opt.isNew) && opt.label.trim() !== '') {
					return {
						id: `new-${Date.now()}-${Math.random()}`,
						dietExerciseName: opt.label.trim(),
					};
				}
				if (opt.value && !opt.__isNew__) {
					return { id: `diet-${opt.value}`, dietExerciseId: opt.value };
				}
				return null;
			})
			.filter(Boolean);

		const newOptions = (selected || [])
			.filter((opt) => opt.__isNew__ && opt.label.trim() !== '')
			.map((opt) => ({
				value: opt.label.trim(),
				label: opt.label.trim(),
				isNew: true,
			}));

		setDietExerciseOptions((prev) => {
			const merged = [...prev, ...newOptions];
			return merged.filter(
				(opt, index, self) =>
					index === self.findIndex((o) => o.value === opt.value)
			);
		});
		setFieldValue('dietExercise', mapped);
	};

	const selectedValue = (values.dietExercise || [])
		.map((item) => {
			if (item.dietExerciseId) {
				return dietExerciseOptions.find(
					(opt) => opt.value === item.dietExerciseId
				);
			}
			if (item.dietExerciseName) {
				return {
					value: `new-${item.dietExerciseName}`,
					label: item.dietExerciseName,
					isNew: true,
				};
			}
			return null;
		})
		.filter(Boolean);

	return (
		<Row className="my-3">
			<Card.Title>{t('VISIT.DIET_AND_EXERCISE')}</Card.Title>
			<Col md={12}>
				<CreatableSelect
					isMulti
					menuPortalTarget={document.body}
					styles={optionsStyle}
					isClearable
					options={dietExerciseOptions}
					value={selectedValue}
					onChange={handleChange}
					onInputChange={(inputValue, { action }) => {
						if (action === 'input-change') {
							setSearchTerm(inputValue);
						}
					}}
					isValidNewOption={(inputValue, _selectValue, selectOptions) =>
						!!inputValue.trim() && !selectOptions.some((opt) => opt.label.toLowerCase() === inputValue.trim().toLowerCase())
					}
					filterOption={(option, rawInput) =>
						!selectedValue.some(
							(sel) => sel.label.toLowerCase() === option.label.toLowerCase()
						) && option.label.toLowerCase().includes(rawInput.toLowerCase())
					}
				/>
			</Col>
		</Row>
	);
};
export default DietExercise;
